import { Filter } from 'labstep-web/constants/filters';

export const filters = [
  Filter.date_range,
  Filter.extension,
  Filter.created_by,
  Filter.deleted,
];
